import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";

const Multiselector = ({title, allValue = "Todos", disabled = false, value, handlerChange, options, formControlHeight = 32, formControlWidth = "10vw", menuItemWitdh = 200, itemHeight = 48, menuItemHeight = "30px", itemWidth = "40vw"}) => {
  
  const getOptionValue = (opt) => (opt?.id ?? opt?.value);
  const getOptionLabel = (opt) => (opt?.label ?? String(opt?.value ?? opt?.name ?? ''));

  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <label className="text-xs text-gray-700 whitespace-nowrap">
        {title}:
      </label>
      <FormControl sx={{ borderRadius: "8px", height: formControlHeight, width: formControlWidth, backgroundColor: "white" }}>
        <InputLabel
          sx={{
            fontSize: 12,
            transform: "translate(14px, 6.5px) scale(1)",
            "&.MuiInputLabel-shrink": {
              transform: "translate(14px, -6px) scale(0.75)",
            },
          }}
        >
          {allValue}
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          sx={{
            height: formControlHeight,
            display: "flex",
            alignItems: "center",
            fontSize: 12,
            borderRadius: "8px",
          }}
          disabled={disabled}
          id="demo-multiple-checkbox"
          multiple
          value={value}
          onChange={(e) => disabled ? null : handlerChange(e.target.value)}
          input={<OutlinedInput label={allValue} sx={{ height: 25, fontSize: 12 }}/>}
          renderValue={(selected) => {
            return selected.map(val => {
              const option = options.find(v => getOptionValue(v) === val);
              return option ? getOptionLabel(option) : '';
            }).filter(Boolean).join(', ');
          }}                
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: itemHeight * 6.5,
                width: menuItemWitdh,
              },
            },
          }}
        >
          {options.map((e) => {
            const optionValue = getOptionValue(e);
            const optionLabel = getOptionLabel(e);
            return (
              <MenuItem disabled={disabled} key={optionValue} value={optionValue} sx={{ height: menuItemHeight, width: itemWidth }}>
                <Checkbox checked={value.includes(optionValue)} />
                <ListItemText primary={optionLabel} primaryTypographyProps={{ fontSize: 12, fontFamily: "poppins" }}/>
            </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  )
}

export default Multiselector;
